<script>
    // Stores
    import { alt, linkInstagram, linkYoutube, linkMapa, linkWaze, linkUber, linkAV, linkWhatsapp, linkTelefone, linkFacebook, linkAPI, textWhatsapp, textTelefone, textEndereco, textAtendimento, textCNPJ, textCreci, textSite} from '../store.js';

	// Componentes
    import { Router, Link, link , Route } from "svelte-routing";
    
    // Code
    let contatos = [
        {   
            name: 'Telefone',
            link: $linkTelefone,
            text: $textTelefone,
            icon: '<i class="fas fa-phone"></i>',
        },
        {   
            name: 'Whatsapp',
            link: $linkWhatsapp,
            text: $textWhatsapp,
            icon: '<i class="fab fa-whatsapp"></i>'
        }
    ];

    let links = [
        {
            name: '2ª Via de Boletos e Extratos',
            text: '2ª Via de Boletos e Extratos',
            link: $linkAV,
            target: '_blank',
            icon: '',
        },        
        {
            name: 'Cadastre seu Imóvel',
            text: 'Cadastre seu Imóvel',
            link: '/anuncie',
            icon: '',
        },
        {
            name: 'Solicite Proposta Condomínio',
            text: 'Solicite Proposta Condomínio',
            link: '/solicite-proposta',
            icon: '',
        },
        {
            name: 'Envie seu Contato',
            text: 'Envie seu Contato',
            link: '/contato',
            icon: '',
        },
    ];

    let localizacao = [
        {
            title: 'Mapa',
            icon: '<i class="fas fa-map-marked-alt"></i>',
            link: $linkMapa,
        },
        {
            title: 'Waze',
            icon: '<i class="fab fa-waze"></i>',
            link: $linkWaze,
        },
        {
            title: 'Uber',
            icon: '<i class="fab fa-uber"></i>',
            link: $linkUber,
        }
    ];

    let social = [
        {   
            title: 'Facebook',
            link: $linkFacebook,
            icon: '<i class="fab fa-facebook-square"></i>'
        },
        {   
            title: 'Instagram',
            link: $linkInstagram,
            icon: '<i class="fab fa-instagram"></i>'
        },
    ];    

</script>

<footer>
    <div class="container">
        <div class="itens text-center">
            <div class="item text-lg-left col-12 col-lg-4">
                <a href="/" title="Home">
                    <img src="/images/logoWhite.png" alt="Logo">
                </a>
                <p class="mt-1"><strong>Gestão imobiliária</strong></p>
                <p>Desde 1995 <br> Atendimento exclusivo para condomínios</p>
            </div>
            <div class="item col-12 col-lg-5">
                <!-- Atendimento -->
                <div class="mb-25">
                    <p class="mb-0"><i class="fas fa-clock"></i> <strong>Atendimento</strong></p>
                    <p>{@html $textAtendimento}</p>
                </div>
                <!-- Endereço -->
                <div class="mb-25">                
                    <p class="mb-0"><i class="fas fa-map-marker-alt"></i> <strong>Endereço</strong></p>
                    <a href="{$linkMapa}" target="_blank" title="Abrir no Google Maps" class="mb-0">{@html $textEndereco}</a>
                    <ul class="list list--point">
                        {#each localizacao as l}
                            <li class="list-item">
                                <a class="icon-transform" href="{l.link}" target="_blank" title="{l.title}{$alt}">{@html l.icon} {l.title}</a>
                            </li>
                        {/each}
                    </ul>
                </div>
                <div class="mb-25">
                    <a href="/privacidade">Política de Privacidade</a>
                </div>                
            </div>
            <!-- Fale com a ControLar -->
            <div class="item text-lg-right col-12 col-lg-3">
                <p>Fale com a ControLar</p>
                <ul>
                    {#each contatos as contato}
                        <li>
                            <h3 class="subtitle icon-transform">                            
                                <a href="{contato.link}" title="{contato.name}{$alt}" target="_blank"><b>{contato.text}</b> {@html contato.icon}</a>
                            </h3>
                        </li>
                    {/each}
                </ul>       
                <ul class="icons-sociais-inline justify-content-lg-end mt-1">
                    {#each social as s}
                        <li class="icon icon-transform">
                            <a href="{s.link}" title="{s.title}{$alt}" target="_blank">{@html s.icon}</a>
                        </li>
                    {/each}
                </ul>                                   
            </div>
        </div>
        <p class="copyright">© Copyright 2020 - {$textSite} - CRECI {$textCreci} - CNPJ {$textCNPJ} - Todos os Direitos Reservados - Desenvolvido por <a href="{$linkAPI}" target="_blank" title="API - Tecnologia Digital Resultados Reais">API</a></p>
    </div>
</footer>